module.exports = __webpack_public_path__ + "ee639bee0cc01fb172c4095cc4dca2f7.png";